export default "__VITE_ASSET__bf2fe5ac__"